import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'zag-app-header',
  imports: [],
  templateUrl: './app-header.html',
  styleUrl: './app-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.zag-app-header]': 'true',
  },
})
export class AppHeader {
  /**
   * The title displayed in the header
   */
  readonly title = input<string>('');

  /**
   * Path or URL to the logo image (optional)
   * If provided, logo is displayed alongside the title
   */
  readonly logo = input<string | undefined>(undefined);

  /**
   * Alt text for the logo image
   */
  readonly logoAlt = input<string>('Application logo');

  /**
   * Emitted when logo is clicked
   */
  readonly logoClick = output<void>();

  /**
   * Handle logo click
   */
  onLogoClick(): void {
    this.logoClick.emit();
  }
}
